export default {
  blue: ({ disabled }) => {
    let bg = 'transparent';
    let textColor = 'primary.700';
    if (disabled) {
      textColor = 'gray.400';
      bg = 'gray.150';
    }
    return ({
      borderRadius: '5px',
      color: `${textColor}`,
      bg: `${bg}`,
      _hover: !disabled && { color: 'primary.900' },
      _active: !disabled && { color: 'primary.1000' },
    });
  },
  teal: ({ disabled }) => {
    let bg = 'transparent';
    let textColor = 'secondary.700';
    if (disabled) {
      textColor = 'gray.400';
      bg = 'gray.150';
    }
    return ({
      borderRadius: '5px',
      color: `${textColor}`,
      bg: `${bg}`,
      _hover: !disabled && { color: 'secondary.900' },
      _active: !disabled && { color: 'secondary.1000' },
    });
  },
};
